var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visiable)?_c('div',{class:[
    'cys-alert',
    {
      default: !_vm.type || _vm.type === 'default',
      success: _vm.type === 'success',
      warning: _vm.type === 'warning',
      error: _vm.type === 'error',
      fadeIn: !_vm.fadeOut && _vm.visiable,
      fadeOut: _vm.fadeOut
    }
  ]},[_c('i',{staticClass:"cysicon"}),_vm._v(" "),_c('div',{class:['cys-alert-message']},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),_c('i',{staticClass:"cysicon close icon-guanbi",on:{"click":_vm.handleClose}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-41958d08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/cys-message/cys-message.vue
// module id = null
// module chunks = 